import React from 'react';

import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { linkTo } from '@storybook/addon-links';

import { Welcome } from '@storybook/react/demo';
import { RelatedCases} from './RelatedCases';

  storiesOf('Case Menu/Related Cases', module)

  .add('Showing', () =>
    <div>
      <h3> Related Cases Component showing some data</h3>
      <hr/>
      <RelatedCases 
        relatedCases={relatedCasesData.data.related_cases_district}
      />
    </div>
  )

  .add('Empty', () => (
    <div>
      <h3> Related Cases Empty</h3>
      <hr/>
      <RelatedCases 
        relatedCases={relatedCasesEmpty.data.related_cases_district}
      />
    </div>
  ))

  const relatedCasesData = {
    data: {
      related_cases_district: [
      {
        "case_uuid"  : "nyebke_42023-111",
        "case_title" : "S.E.C. v. Walsh",
        'case_no'    : '1:02-cv-09921',
        "end_date" : '05/24/2005',
        "start_date": "05/24/2004"
      },
      {
        "case_uuid"  : "nyebke_283201",
        "case_title" : "Securities and Exchange Commission v. Tyco International Ltd.",
        'case_no'    : '1:06-cv-02942',
        "end_date" : '',
        "start_date": "07/20/2004"
      },
      {
        "case_uuid"  : "nyebke_296957",
        "case_title" : "United States Securities and Exchange Commission v. Power et al",
        'case_no'    : '1:06-cv-15343',
        "end_date" : '',
        "start_date": "09/29/2004"
      },
    ]
   }
 }

  const relatedCasesEmpty= {
    data: {
      related_cases_district: {
         'empty' : "There are no related cases."
       },
    }
  }




// WEBPACK FOOTER //
// ./src/components/case/associated_cases/RelatedCases.stories.jsx